module.exports = __webpack_public_path__ + "static/media/tooltip-info.6345683f.svg";